import { ActionContext, ActionTree } from 'vuex'
import { mutationType } from './mutation-types'
import SosState, {SosList} from './states'
import _ from 'lodash'
import { State } from '@/store/store'
import axios from 'axios'
import httpRequest from '../../../../services/HttpRequestServiceWithToken'

const actions: ActionTree<SosState, State> = {
  async getSosList(
    { commit, dispatch, state }: ActionContext<SosState, State>,
    options: object,
  ): Promise<void> {
    await httpRequest
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', 'sos', options, (res: SosList) => {
        commit(mutationType.GET_LISTS, res)
      })
  },
}

export default actions
